import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BCard, BTab, BTabs } from "bootstrap-vue";
import { computed, ref } from "vue";
import { RouterLink } from "vue-router";
import { useConfig } from "@/composables/config";
import { useFileSources } from "@/composables/fileSources";
import { useToast } from "@/composables/toast";
import { useHistoryStore } from "@/stores/historyStore";
import HistoryArchiveExportSelector from "@/components/History/Archiving/HistoryArchiveExportSelector.vue";
import HistoryArchiveSimple from "@/components/History/Archiving/HistoryArchiveSimple.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryArchiveWizard',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive);
        const historyStore = useHistoryStore();
        const { config } = useConfig(true);
        const toast = useToast();
        const { hasWritable: hasWritableFileSources } = useFileSources();
        const isArchiving = ref(false);
        const history = computed(() => {
            const history = historyStore.getHistoryById(props.historyId);
            if (history === null) {
                // It could be already an archived history, so we won't find it in the store
                // as it's not in the active histories anymore.
                historyStore.loadHistoryById(props.historyId);
                return historyStore.getHistoryById(props.historyId);
            }
            return history;
        });
        const isHistoryAlreadyArchived = computed(() => {
            return history.value?.archived;
        });
        const canFreeStorage = computed(() => {
            return hasWritableFileSources.value && config.value.enable_celery_tasks;
        });
        const archivedHistoriesRoute = "/histories/archived";
        async function onArchiveHistory(exportRecordId) {
            isArchiving.value = true;
            try {
                const shouldPurge = exportRecordId !== undefined;
                await historyStore.archiveHistoryById(props.historyId, exportRecordId, shouldPurge);
                toast.success("History archived successfully.");
            }
            catch (error) {
                toast.error(`The history archive request failed. Please try again later. Reason: ${error}`);
            }
            finally {
                isArchiving.value = false;
            }
        }
        return { __sfc: true, historyStore, config, toast, hasWritableFileSources, props, isArchiving, history, isHistoryAlreadyArchived, canFreeStorage, archivedHistoriesRoute, onArchiveHistory, FontAwesomeIcon, BAlert, BCard, BTab, BTabs, RouterLink, HistoryArchiveExportSelector, HistoryArchiveSimple, LoadingSpan };
    }
});
